// extracted by mini-css-extract-plugin
var _1 = "O_GLyxqwZsepWtPhSHIa";
var _2 = "xh4SZxRYwhBM4f6WiHip";
var _3 = "P3S88VnAlDWZ3VTstWY5";
var _4 = "He8CxSsahI50WXbTVtrV";
var _5 = "ASh3585TP_tsouAVHKAT";
var _6 = "NX4CRm11A25M0LkbP3qo";
var _7 = "S8lSymAijK5uvCScsG3s";
var _8 = "aFjmbWIpz759M9cg8Jzh";
var _9 = "VwM9yy4bbvuA5In5LTUr";
var _a = "INTg_BbbGZvrhL_7vINs";
var _b = "nRNgK2xbHUWa2URMDqyA";
export { _1 as "bold", _2 as "group__code", _3 as "image", _4 as "infoBox", _5 as "infoBoxTitle", _6 as "join", _7 as "label", _8 as "list", _9 as "subtitle", _a as "symbol", _b as "textCenter" }
